// Ported verbatim from the LeadMailer Design System (components/forms/Select.jsx).
import React from 'react'
import { useFieldStyle } from './Field'
import type { ControlSize } from './Button'

export type SelectOption = string | { value: string; label: string }

export interface SelectProps
  extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange' | 'size'> {
  options?: SelectOption[]
  size?: ControlSize
  error?: React.ReactNode
  onChange?: (value: string) => void
}

export function Select({
  options = [],
  size = 'md',
  error,
  style,
  onChange,
  value,
  ...rest
}: SelectProps) {
  const [fs, handlers] = useFieldStyle(error)
  const h = {
    sm: 'var(--control-h-sm)',
    md: 'var(--control-h-md)',
    lg: 'var(--control-h-lg)',
  }[size]

  return (
    <div style={{ position: 'relative', display: 'inline-flex', width: '100%', ...style }}>
      <select
        value={value}
        {...handlers}
        onChange={(e) => onChange && onChange(e.target.value)}
        style={{ ...fs, height: h, padding: '0 32px 0 12px', appearance: 'none', cursor: 'pointer' }}
        {...rest}
      >
        {options.map((o) =>
          typeof o === 'string' ? (
            <option key={o} value={o}>
              {o}
            </option>
          ) : (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ),
        )}
      </select>
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{
          position: 'absolute',
          right: 10,
          top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          color: 'var(--text-muted)',
        }}
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </div>
  )
}
